import { react2angular } from 'react2angular';
import AppointmentConfigContacts from './AppointmentConfigContacts';

(() => {
  angular
    .module('bb.appointments')
    .component(
      'bbConfigContacts',
      react2angular(
        AppointmentConfigContacts,
        [
          'contacts',
          'listingId',
          'listing',
          'contactsToConfirm',
          'listingAgentConfirm',
          'updateContacts',
          'userId',
          'isProfile',
          'answeringSubscriptionExists',
          'isMustCallDisabled',
        ],
        ['ModalService', '$scope', '$rootScope'],
      ),
    );
})();
